var _classCallCheck = require("/home/vsts/work/1/s/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vsts/work/1/s/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var customMessage = require('./customMessage');

var yup = require('yup');

yup.setLocale(customMessage);

module.exports = /*#__PURE__*/function () {
  "use strict";

  function Model(definition) {
    _classCallCheck(this, Model);

    this.definition = Object.freeze(definition);
    this.validatorInstance = yup.object(definition).camelCase();
  }

  _createClass(Model, [{
    key: "validate",
    value: function validate(obj, options) {
      return this.validatorInstance.validate(obj, options);
    }
  }, {
    key: "create",
    value: function create(input) {
      return Object.keys(this.definition).reduce(function (acc, curr) {
        acc[curr] = (input || {})[curr];
        return acc;
      }, {});
    }
  }]);

  return Model;
}();